import { Paragraph } from '@vimeo/iris/typography';

export default function RPC() {
  return (
    <div>
      <Paragraph size="2">
        A <i>remote procedure call</i>, or RPC, enables you to locally execute a program or service
        that is located on another computer or network.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
